import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form, Button } from 'semantic-ui-react'

import SeguroPermite from '../../../components/funcionales/seguropermite'

import XLSX from 'xlsx'
import { saveAs } from 'file-saver';

//utils
import queries from '../../../utils/queries'
var moment = require('moment');

const DetallePl = ({elemento, indice, handleChange}) => {
  let numDiasFact= 0
  let colorCeldaFact='white'
  if(elemento.estadoOC!=='Cancelada'){
    if(elemento.fechaFact){
      numDiasFact = moment(elemento.fechaFact, 'YYYY-MM-DD').diff(moment(elemento.fechaSolic, 'YYYY-MM-DD'), 'days') 
    }else{
      numDiasFact = moment(new Date(), 'YYYY-MM-DD').diff(moment(elemento.fechaSolic, 'YYYY-MM-DD'), 'days') 
    }
    if(parseInt(numDiasFact)>3){
      colorCeldaFact = 'red'
    }else{
      if(parseInt(numDiasFact)>=2){
        colorCeldaFact = 'yellow'
      }else{
        colorCeldaFact = 'green'
      }
    }
  }

  return(
    <tr className=''>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.numOrdenCompra}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.ordenCompraCliente}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.estadoOC}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.usuarioSolic}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fechaSolic.substr(0, 10)}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.consecDespacho}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrEmpresa}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.numAvance}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.numFactura?elemento.numFactura:''}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.usuarioFact}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fechaFact?elemento.fechaFact.substr(0, 10):''}</td>
      <td className='' style={{color: 'black', background: colorCeldaFact, paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{numDiasFact}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.valorFact}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.valorPagado?elemento.valorPagado:0}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.monedaCoti}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.trmFactura?elemento.trmFactura:0}</td>
    </tr>
  )
};
const ListaPl = ({list, handleChange}) => {
    const nivel1Detalle = list.map((elemento, i) => <DetallePl elemento={elemento} key={i} indice={i}
      handleChange={handleChange}/>);
    return(
      <tbody className=''>
        {nivel1Detalle}
      </tbody>
    )
  };

class GerSegFac2 extends React.Component {
  state={list: this.props.allCotizacionRtes.allCotizacionRtes?this.props.allCotizacionRtes.allCotizacionRtes:[],
    argsDocum: {desde: this.props.fechaHoy, hasta: this.props.fechaFin, diasDesde: this.props.diasDesde, diasHasta: this.props.diasHasta},
    permiteUpdate: true, confirmaAct: false, open: false, argsBuscCoti: {}, ingresa: 'S',
    argsQuery: `{"$unwind": "$itemsFactura"},
      {$project: {_id: 1, tipoCoti: 1, tipo: 1, numCoti: 1, descrEmpresa: 1, estadoOC: 1, monedaCoti: 1,
        numOrdenCompra: {"$toString": "$numOrdenCompra"}, ordenCompraCliente: 1,
        fechaSolic: '$itemsFactura.fechaSolic', fechaFact: '$itemsFactura.fechaFact', numAvance: {"$toString": "$itemsFactura.numAvance"}, 
        usuarioSolic: '$itemsFactura.usuarioSolic', usuarioFact: '$itemsFactura.usuarioFact', valorFact: '$itemsFactura.valorFact', 
        valorPagado: '$itemsFactura.valorPagado', trmFactura: '$itemsFactura.trmFactura', numFactura: '$itemsFactura.numFactura'}},
      {$lookup: {from: 'usuarios', localField: 'usuarioSolic', foreignField: 'email', as: 'usuario'}},
        {$unwind: '$usuario'},
      {$project: {_id: {$concat: ['$numOrdenCompra', '$numAvance']}, tipoCoti: 1, tipo: 1, numCoti: 1, descrEmpresa: 1, estadoOC: 1, monedaCoti: 1,
      numOrdenCompra: 1, ordenCompraCliente: 1,
        fechaSolic: 1, fechaFact: 1, numAvance: 1, usuarioSolic: '$usuario.nombreUsuario', usuarioFact: 1, valorFact: 1, 
        valorPagado: 1, trmFactura: 1, numFactura: 1,
        consecDespacho: {
          $let: {
            vars: {fechaSolicDif: "$fechaSolic"},
           in: {$cond: [
             {
               "$or":[
                { "$eq": [ "$$fechaSolicDif", null ] },
                { "$eq": [ "$$fechaSolicDif", '' ]},
               ]
             }, 
             1,
             { $toInt: {$divide: [{$subtract: [ new Date(), {"$toDate": '$$fechaSolicDif'} ]}, 86400000 ]}}
            ]
          }}
        }}},
      {$sort: {fechaSolic: 1}}`
  }

  handleChange = async (ev, indice) => {
    if(ev.target.name==="desde"||ev.target.name==="hasta"){
      const argsDocum = this.state.argsDocum
      argsDocum[ev.target.name] = ev.target.value
      let diasdif1= new Date().getTime()-new Date(argsDocum.desde).getTime()
      argsDocum['diasDesde'] = Math.round(diasdif1/(1000*60*60*24))-1
      let diasdif2= new Date().getTime()-new Date(argsDocum.hasta).getTime()
      argsDocum['diasHasta'] = Math.round(diasdif2/(1000*60*60*24))-1
      let argsBuscar=`'tipoCoti': 'Cliente', 'estadoOC': {$ne: 'Cerrada'}, 'numOrdenCompra': {$gt: 0}`
      if(this.props.argsBuscCoti.usuarioSolic){
        argsBuscar += `, 'usuarioSolic': /${this.props.argsBuscCoti.usuarioSolic}/i`
      }
      if(this.props.argsBuscCoti.usuarioFact){
        argsBuscar += `, 'usuarioFact': /${this.props.argsBuscCoti.usuarioFact}/i`
      }      
      if(this.props.argsBuscCoti.numOrdenCompra){
        argsBuscar += `, 'numOrdenCompra': ${this.props.argsBuscCoti.numOrdenCompra}`
      }
      if(this.props.argsBuscCoti.ordenCompraCliente){
        argsBuscar += `, 'ordenCompraCliente': /${this.props.argsBuscCoti.ordenCompraCliente}/i`
      }
      if(this.props.argsBuscCoti.numFactura){
        argsBuscar += `, 'numFactura': /${this.props.argsBuscCoti.numFactura}/i`
      }
      if(this.props.argsBuscCoti.descrEmpresa){
        argsBuscar += `, 'descrEmpresa': /${this.props.argsBuscCoti.descrEmpresa}/i`
      }
      if(this.props.argsBuscCoti.estadoOC){
        argsBuscar += `, 'estadoOC': /${this.props.argsBuscCoti.estadoOC}/i`
      }
      // console.log(argsDocum)
      let argsBuscar2=`consecDespacho: {$gte: ${argsDocum.diasHasta}}, consecDespacho: {$lte: ${argsDocum.diasDesde}},`
      // if(ev.target.name==="desde"){
      //   // fechaDesde = moment(argsDocum.hasta).format('YYYY-MM-DD')
      //   // argsBuscar2 = `fechaSolic: { $lte: new Date('${argsDocum.hasta}') }`
      //   argsBuscar2 = `fechaSolic: { $gte: '${ev.target.value}'}, fechaSolic: { $lte: '${argsDocum.hasta}' }`
      // }else{
      //   // fechaDesde = moment(ev.target.value).format('YYYY-MM-DD')
      //   // argsBuscar2 = `fechaSolic: { $lte: new Date('${ev.target.value}') }`
      //   argsBuscar2 = `fechaSolic: { $gte: '${argsDocum.desde}'}, fechaSolic: { $lte: '${ev.target.value}' }`
      // }

      let argsBuscarPl = {tipoqry: `[{$match: {${argsBuscar}}}, ${this.state.argsQuery}, 
        {$match: {${argsBuscar2}}}, 
        {$sort: {fechaSolic: -1}}]`}

      console.log(argsBuscarPl)
      await this.props.allCotizacionRtes.refetch(argsBuscarPl)
      if(this.props.allCotizacionRtes.allCotizacionRtes){
        this.setState({list: 
          this.props.allCotizacionRtes.allCotizacionRtes?this.props.allCotizacionRtes.allCotizacionRtes:[]
        })
      }
      this.setState({argsDocum});
    }
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){
      this.setState({open: true})
    }else{
      this.setState({open: false})
    };
    if(btnPress==="No"){
      this.setState({open: false})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      const myBtn = await document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  async componentDidMount(prevProps){
    const argsDocum = this.state.argsDocum
    console.log(argsDocum)
    if(this.state.ingresa==='S'){
      let argsBuscar=`'tipoCoti': 'Cliente', 'estadoOC': {$ne: 'Cerrada'}, 'numOrdenCompra': {$gt: 0}`
      if(this.props.argsBuscCoti.usuarioSolic){
        argsBuscar += `, 'usuarioSolic': /${this.props.argsBuscCoti.usuarioSolic}/i`
      }
      if(this.props.argsBuscCoti.usuarioFact){
        argsBuscar += `, 'usuarioFact': /${this.props.argsBuscCoti.usuarioFact}/i`
      }  
      if(this.props.argsBuscCoti.ordenCompraCliente){
        argsBuscar += `, 'ordenCompraCliente': /${this.props.argsBuscCoti.ordenCompraCliente}/i`
      }
      if(this.props.argsBuscCoti.numOrdenCompra){
        argsBuscar += `, 'numOrdenCompra': ${this.props.argsBuscCoti.numOrdenCompra}`
      }
      if(this.props.argsBuscCoti.numFactura){
        argsBuscar += `, 'numFactura': /${this.props.argsBuscCoti.numFactura}/i`
      }
      if(this.props.argsBuscCoti.descrEmpresa){
        argsBuscar += `, 'descrEmpresa': /${this.props.argsBuscCoti.descrEmpresa}/i`
      }
      if(this.props.argsBuscCoti.estadoOC){
        argsBuscar += `, 'estadoOC': /${this.props.argsBuscCoti.estadoOC}/i`
      }
      let argsBuscar2=`consecDespacho: {$gte: ${argsDocum.diasHasta}}, consecDespacho: {$lte: ${argsDocum.diasDesde}},`
      // let argsBuscar2 = `fechaSolic: { $gte: '${this.state.argsDocum.desde}'}, fechaSolic: { $lte: '${this.state.argsDocum.hasta}' }`
      let argsBuscarPl = {tipoqry: `[{$match: {${argsBuscar}}}, ${this.state.argsQuery}, {$match: {${argsBuscar2}}}, {$sort: {fechaSolic: -1}}]`}

      console.log(argsBuscarPl)
      await this.props.allCotizacionRtes.refetch(argsBuscarPl)
      if(this.props.allCotizacionRtes.allCotizacionRtes){
        this.setState({list: 
          this.props.allCotizacionRtes.allCotizacionRtes?this.props.allCotizacionRtes.allCotizacionRtes:[]
        })
      }
      this.setState({ingresa: 'N'})
    }
  }

  async componentDidUpdate(prevProps){
    const argsDocum = this.state.argsDocum
    // console.log(argsDocum)
    if(this.props.argsBuscCoti!==prevProps.argsBuscCoti || this.state.ingresa==='S'){
      let argsBuscar=`'tipoCoti': 'Cliente', 'estadoOC': {$ne: 'Cerrada'}, 'numOrdenCompra': {$gt: 0}`
      if(this.props.argsBuscCoti.usuarioSolic){
        argsBuscar += `, 'usuarioSolic': /${this.props.argsBuscCoti.usuarioSolic}/i`
      }
      if(this.props.argsBuscCoti.usuarioFact){
        argsBuscar += `, 'usuarioFact': /${this.props.argsBuscCoti.usuarioFact}/i`
      }  
      if(this.props.argsBuscCoti.ordenCompraCliente){
        argsBuscar += `, 'ordenCompraCliente': /${this.props.argsBuscCoti.ordenCompraCliente}/i`
      }
      if(this.props.argsBuscCoti.numOrdenCompra){
        argsBuscar += `, 'numOrdenCompra': ${this.props.argsBuscCoti.numOrdenCompra}`
      }
      if(this.props.argsBuscCoti.numFactura){
        argsBuscar += `, 'numFactura': /${this.props.argsBuscCoti.numFactura}/i`
      }
      if(this.props.argsBuscCoti.descrEmpresa){
        argsBuscar += `, 'descrEmpresa': /${this.props.argsBuscCoti.descrEmpresa}/i`
      }
      if(this.props.argsBuscCoti.estadoOC){
        argsBuscar += `, 'estadoOC': /${this.props.argsBuscCoti.estadoOC}/i`
      }
      let argsBuscar2=`consecDespacho: {$gte: ${argsDocum.diasHasta}}, consecDespacho: {$lte: ${argsDocum.diasDesde}},`
      // let argsBuscar2 = `fechaSolic: { $gte: '${this.state.argsDocum.desde}'}, fechaSolic: { $lte: '${this.state.argsDocum.hasta}' }`
      let argsBuscarPl = {tipoqry: `[{$match: {${argsBuscar}}}, ${this.state.argsQuery}, {$match: {${argsBuscar2}}}, {$sort: {fechaSolic: -1}}]`}

      console.log(argsBuscarPl)
      await this.props.allCotizacionRtes.refetch(argsBuscarPl)
      if(this.props.allCotizacionRtes.allCotizacionRtes){
        this.setState({list: 
          this.props.allCotizacionRtes.allCotizacionRtes?this.props.allCotizacionRtes.allCotizacionRtes:[]
        })
      }
      this.setState({ingresa: 'N'})
    }
  }

  render(){
    const {list, argsDocum, checkSeleccInfAll, permiteUpdate, confirmaAct, open} = this.state;

    // const a250110 = autorizacUA.findIndex( autorizac => autorizac === "250110" );
    let mensaje = "Generar Excel de informe"
    let imgIcon = "images/documento_32.png"
    

    // trmcol.query('2023-05-15')
    //   .then(trm => console.log(trm))
    //   .catch(err => console.log(err))
    

// console.log(list)

//     let list1 = []
//     if(list.length>0){
//       list1=list
//     }else{
//       if(this.props.allCotizacionRtes.allCotizacionRtes){
//         this.props.allCotizacionRtes.refetch()
//         list1 = this.props.allCotizacionRtes.allCotizacionRtes
//       }
//     }
// console.log(list1)

    return (
      // <div>
        <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
          <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.handleSubmit(ev, list, argsDocum):()=>{}}>
            <div className="ui three column stackable grid">
              <div className="row container">
                <div className="column" style={{width: '15%'}}>
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                    Desde
                  </p>
                  <Form.Field>
                    <input style={this.props.styles.input} type='date' name="desde" id="desde" value={argsDocum.desde} onChange={this.handleChange}/>
                  </Form.Field>
                </div>
                <div className="column" style={{width: '15%'}}>
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                    Hasta
                  </p>
                  <Form.Field>
                    <input style={this.props.styles.input} type='date' name="hasta" id="hasta" value={argsDocum.hasta} onChange={this.handleChange}/>
                  </Form.Field>
                </div>
                {localStorage.getItem('userLogin')==="slcm@slcm.com" &&
                  <div className="column" style={{width: '18%', paddingTop: '0.3em'}}>
                    <Button id="excel" name="excel" style={this.props.styles.confirmar} onClick={(ev)=>this.handleGenExc(ev, argsDocum)} fluid>
                      Excel administrativo
                    </Button>
                  </div>
                } 
              </div>
            </div>
            <br></br>
            <div>
              <div style={{height: '45em', overflow: 'auto'}}>
                <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                  <thead className=''>
                    <tr className=''>
                      <th className='' position = 'sticky' top = '0' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>OC LCM</th>
                      <th className='' position = 'sticky' top = '0' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>OC Cliente</th>
                      <th className='' position = 'sticky' top = '0' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Estado</th>
                      <th className='' position = 'sticky' top = '0' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Solicitó</th>
                      <th className='' position = 'sticky' top = '0' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Fecha Solicitud.</th>
                      <th className='' position = 'sticky' top = '0' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Dias transcurridos</th>
                      <th className='' position = 'sticky' top = '0' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Cliente</th>
                      <th className='' position = 'sticky' top = '0' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}># Avance</th>
                      <th className='' position = 'sticky' top = '0' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Factura</th>
                      <th className='' position = 'sticky' top = '0' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Usuario Facturó</th>
                      <th className='' position = 'sticky' top = '0' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Fecha facturación</th>
                      <th className='' position = 'sticky' top = '0' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Días facturación</th>
                      <th className='' position = 'sticky' top = '0' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Valor factura</th>
                      <th className='' position = 'sticky' top = '0' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Valor pagado</th>
                      <th className='' position = 'sticky' top = '0' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Moneda</th>
                      <th className='' position = 'sticky' top = '0' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>TRM al facturar</th>
                     </tr>
                  </thead>
                  <ListaPl list={list} handleChange={this.handleChange}/>
                </table>
                <p></p>
              </div>
            </div>
          </Form>
        </div>
      // </div>
    )
  }
};

export default compose(
  graphql(queries.query.allCotizacionRtes, {name:'allCotizacionRtes',
    options: (props) => {return {variables: {tipoqry: `[{$match: {descrEmpresa: 'Seleccionar Empresa...'}}]`}}}}),

  graphql(queries.mutation.fecha, {name:'fecha'}),
)(GerSegFac2)
